module.exports = __webpack_public_path__ + "img/demo-thumb.67b626d2.jpg";